RivalIQ.apps.SocialPosts.module('curations', function (curations, App, Backbone, Marionette, $, _, s) {

    'use strict';


    function showPostTagsTour(curation) {

        if (curation.isFocus() &&
            !curation.isExporting()) {

            return RivalIQ.postTags.data.PostTags.fetch()
                .then(function (postTags) {
                    if (!_.isEmpty(postTags)) {
                        const tourOptions = {
                            tourId: 'post-tags-tour',
                            autoscroll: true,
                            closeButtonText: 'Got it!',
                            startDelay: 0,
                            steps: [
                                {
                                    element: '.x-post-tags-filter .multi-select-dropdown',
                                    content: '<p>Filter your analytics by selecting tags from this dropdown.</p>',
                                    placement: 'bottom',
                                    bodyClass: 'post-tags-tour-1'
                                }
                            ]
                        };

                        RivalIQ.execute('tour:start', tourOptions);
                    }
                });
        }
    }

    function createBulkEditBtn(dashboardModel) {

        const className = 'btn-link pointer x-bulk-edit-tags';

        return new RivalIQ.views.Link({
            className: className,
            linkName: 'Post Tag Manager',
            action: function () {

                const clickSourceInfo = {
                    clickSource: 'actionsButton',
                    feature: 'social posts',
                    channel: dashboardModel.getProp('channel')
                };

                App.utils.showPostTagsManager(dashboardModel, clickSourceInfo);
            }
        });
    }

    curations.PostTags = curations.SocialPosts.extend({
        title: 'Post Tags',

        exportFormats: [
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PPT
        ],

        afterFilters: [
            showPostTagsTour
        ],

        widgetsView: curations.Layout.extend({
            getConfig: _.constant([
                {
                    name: 'post-tags',
                    sizes: {
                        md: 12
                    },
                    page: 0
                },
                {
                    name: 'posts',
                    sizes: {
                        md: 12
                    },
                    page: 1
                }
            ]),

            showActions: function () {
                const me = this;

                me.actions.empty();
                me.actions.show(createBulkEditBtn(me.dashboardModel), {
                    preventDestroy: true
                });

                me.showExportDropdown();
            }
        }),

        widgetView: curations.SocialPostDetailsLayout.extend({
            template: '#postTagsDetailsLayoutTemplate',
            showToolbarActions: function () {
                const me = this;

                me.actions.empty();
                me.actions.show(createBulkEditBtn(me.dashboardModel), {
                    preventDestroy: true
                });
                me.showExportDropdown();
            },

            loadData: function () {
                const me = this;

                const curation = _.get(me.dashboardModel, ['curation'], me.dashboardModel);
                let concept = RivalIQ.metrics.descriptions.SOCIAL_POSTS.id;
                if (curation.id === RivalIQ.enums.curation.POSTED_URLS) {
                    concept = RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id;
                }
                const definition = new RivalIQ.models.MetricDefinition({
                    concept: concept
                });
                App.utils.updateMetric(definition, me.getProps());

                const fetches = [
                    definition.fetch()
                ];

                if (me.getProp('isInPostTagEditMode')) {
                    fetches.push(RivalIQ.postTags.data.PostTags.fetch());
                }

                return $.when.apply($, fetches)
                    .then(function (metric, postTags) {
                        me.postTags = postTags;
                        me.metric = metric;
                        me.hasPosts = (metric.getValue({
                            format: false
                        }) > 0);
                        // reset to ignore any previous error
                        me.errorName = null;
                        const curation = me.dashboardModel.curation || me.dashboardModel;
                        if (curation.showTour && me.hasPosts) {
                            curation.showTour();
                        }
                    });
            }
        }),

        getCurationId: function () {
            const me = this;
            return s.dasherize([me.id.toLowerCase(), me.getProp('channel')].join('-'));
        }
    });

}, window.s);
